import { getFile } from '@/api/query/file';
import { normalizeFileId } from '@/common/hooks/useImage';

const pendingIds = new Set();

export const preloadStoryMedia = (fileIds) => {
	fileIds.forEach((rawId) => {
		const id = normalizeFileId(rawId);

		if (!id || pendingIds.has(id)) {
			return;
		}

		pendingIds.add(id);

		getFile(id)
			.catch(() => {})
			.finally(() => {
				pendingIds.delete(id);
			});
	});
};

export const collectStoryMediaIds = (storyPerson) => {
	if (!storyPerson) {
		return [];
	}

	const ids = new Set();

	storyPerson.stories.forEach((story) => {
		if (story.mediaId) {
			ids.add(story.mediaId);
		}

		if (story.previewMediaId) {
			ids.add(story.previewMediaId);
		}
	});

	const profileId = storyPerson.person?.profile_image?._id
		?? storyPerson.person?.profile_image;

	if (profileId) {
		ids.add(profileId);
	}

	return [...ids];
};
